/**
 * PAGE
 */

enum Login {
  Title = 'Page-Login-Title',
  Submit = 'Page-Login-Submit',
}
enum Register {
  Title = 'Page-Register-Title',
  Submit = 'Page-Register-Submit',
}
enum ForgotPassword {
  Title = 'Page-ForgotPassword-Title',
  Submit = 'Page-ForgotPassword-Submit',
  Processed = 'Page-ForgotPassword-Processed',
  AlreadyHaveAccount = 'Page-ForgotPassword-AlreadyHaveAccount',
}
enum ResetPassord {
  Title = 'Page-ResetPassord-Title',
  Submit = 'Page-ResetPassord-Submit',
  WrongUrlParameters = 'Page-ResetPassord-WrongUrlParameters',
  Success = 'Page-ResetPassord-Success',
  Failure = 'Page-ResetPassord-Failure',
}

enum ProfilesPage {
  Title = 'Page-ProfilesPage-Title',
  SubscriptionActivated = 'Page-ProfilesPage-SubscriptionActivated',
}

enum ContactsPage {
  Title = 'Page-ContactsPage-Title',
  Username = 'Page-ContactsPage-Username',
  IsFollowing = 'Page-ContactsPage-IsFollowing',
  FollowersCount = 'Page-ContactsPage-FollowersCount',
  LastStoryMention = 'Page-ContactsPage-LastStoryMention',
  LastInteraction = 'Page-ContactsPage-LastInteraction',
  FirstInteraction = 'Page-ContactsPage-FirstInteraction',
}

enum AutomationPage {
  Title = 'Page-AutomationPage-Title',
  Status = 'Page-AutomationPage-Status',
  StatusLive = 'Page-AutomationPage-StatusLive',
  StatusScheduled = 'Page-AutomationPage-StatusScheduled',
  StatusPaused = 'Page-AutomationPage-StatusPaused',
  Settings = 'Page-AutomationPage-Settings',
  Save = 'Page-AutomationPage-Save',
  Edit = 'Page-AutomationPage-Edit',
}

enum ProfileSettingsPage {
  Title = 'Page-ProfileSettingsPage-Title',
  InstagramUserID = 'Page-ProfileSettingsPage-InstagramUserID',
  InstagramUsername = 'Page-ProfileSettingsPage-InstagramUsername',
  InstagramPermissions = 'Page-ProfileSettingsPage-InstagramPermissions',
  DangerZone = 'Page-ProfileSettingsPage-DangerZone',
  DeleteButton = 'Page-ProfileSettingsPage-DeleteButton',
  DeleteExplanation = 'Page-ProfileSettingsPage-DeleteExplanation',
  DeleteProfil = 'Page-ProfileSettingsPage-DeleteProfil',
  PlanAndBilling = 'Page-ProfileSettingsPage-PlanAndBilling',
}

enum UserProfilePage {
  Title = 'Page-UserProfilePage-Title',
  DeleteWholeAccountTitle = 'Page-UserProfilePage-DeleteWholeAccountTitle',
  DeleteWholeAccountDescription = 'Page-UserProfilePage-DeleteWholeAccountDescription',
  DeleteWholeAccountConfirmation = 'Page-UserProfilePage-DeleteWholeAccountConfirmation',
  AccountDeleted = 'Page-UserProfilePage-AccountDeleted',
}

enum OnboardingRegistrationPage {
  Error = 'Page-Onboarding-Registration-Error',
  DescriptionError = 'Page-Onboarding-Registration-Description-Error',
  Back = 'Page-Onboarding-Registration-Back',
  HappyToSeeYou = 'Page-Onboarding-Registration-HappyToSeeYou',
}

enum OnboardingStepsIndustryPage {
  FieldActivity = 'Page-Industry-Field-Activity',
  CheckMention = 'Page-Industry-Check-Mention',
  Continue = 'Page-Industry-Continue',
}

enum OnboardingStepsNamePage {
  Name = 'Page-OnboardingStepsName-Name',
}

enum OnboardingStepsEmailPage {
  Email = 'Page-OnboardingStepsEmail-Email',
}

enum OnboardingStepsPasswordPage {
  Password = 'Page-OnboardingStepsName-Password',
}

enum ProfileFormDeletePage {
  Delete = 'Page-ProfileFormDelete-Delete',
  AllDataDelete = 'Page-ProfileFormDelete-AllDataDelete',
  InputConfirmation = 'Page-ProfileFormDelete-InputConfirmation',
}

/**
 * LAYOUT
 */
enum LayoutProfileHeader {
  Audience = 'Layout-ProfileHeader-Audience',
  Campaigns = 'Layout-ProfileHeader-Campaigns',
  Automation = 'Layout-ProfileHeader-Automation',
  Activity = 'Layout-ProfileHeader-Activity',
  Settings = 'Layout-ProfileHeader-Settings',
}

enum LayoutRightHeader {
  Profile = 'Layout-RightHeader-Profile',
  Legal = 'Layout-RightHeader-Legal',
  Settings = 'Layout-RightHeader-Settings',
  Lang = 'Layout-RightHeader-Lang',
  Logout = 'Layout-RightHeader-Logout',
}

/**
 * COMPONENT
 */

enum ComponentAnswerAnalytics {
  TotalSent = 'Component-Answer-Analytics-TotalSent',
  OpeningRate = 'Component-Answer-Analytics-OpeningRate',
}
enum ComponentAnswerCard {
  IfUserIsFollower = 'Component-Answer-Card-IfUserIsFollower',
  IfUserIsNotFollower = 'Component-Answer-Card-IfUserIsNotFollower',
}
enum ComponentAnswerList {
  ButtonInteractions = 'Component-Answer-List-ButtonInteractions',
  Attachments = 'Component-Answer-List-Attachments',
}

enum ComponentAutomationUpdate {
  Status = 'Component-Automation-Update-Status',
  ReactionLabel = 'Component-Automation-Update-ReactionLabel',
  ReactionHelp = 'Component-Automation-Update-ReactionHelp',
  MessageDelayLabel = 'Component-Automation-Update-MessageDelayLabel',
  MessageDelayHelp = 'Component-Automation-Update-MessageDelayHelp',
  Follower = 'Component-Automation-Update-Follower',
  NonFollower = 'Component-Automation-Update-NonFollower',
  ReplyDelayLabel = 'Component-Automation-Update-ReplyDelayLabel',
  ReplyDelayHelp = 'Component-Automation-Update-ReplyDelayHelp',
  ReplyLimitLabel = 'Component-Automation-Update-ReplyLimitLabel',
  ReplyLimitHelp = 'Component-Automation-Update-ReplyLimitHelp',
}

enum ComponentProfileAddCard {
  ConnectError = 'Component-Profile-AddCard-ConnectError',
  RegisterError = 'Component-Profile-AddCard-RegisterError',
  RegisterErrorDetails = 'Component-Profile-AddCard-RegisterErrorDetails',
  RegisterErrorDetailsAlreadyConnected = 'Component-Profile-AddCard-RegisterErrorDetailsAlreadyConnected',
  TryAgain = 'Component-Profile-AddCard-TryAgain',
  Connect = 'Component-Profile-AddCard-Connect',
  Awaiting = 'Component-Profile-AddCard-Awaiting',
  Creating = 'Component-Profile-AddCard-Creating',
}

enum ComponentProfileBillingPortal {
  BillingPortal = 'Component-Profile-Billing-Portal-Billing-Portal',
}

enum ComponentProfileConnectFlow {
  AddInstagramAccount = 'Component-Profile-Connect-Flow-Add-Instagram-Account',
  CheckMention = 'Component-Profile-Connect-Flow-Check-Mention',
  LoginWithInstagram = 'Component-Profile-Connect-Flow-Login-With-Instagram',
  Welcome = 'Component-Profile-Connect-Flow-Welcome',
  ChoosePlan = 'Component-Profile-Flow-Choose-Plan',
  InstagramConnection = 'Component-Profile-Connect-Flow-Instagram-Connection',
}

enum ComponentProfileCard {
  AutomationIsLive = 'Component-Profile-Card-AutomationIsLive',
  AutomationIsPaused = 'Component-Profile-Card-AutomationIsPaused',
  ChoosePlanForUser = 'Component-Profile-Card-ChoosePlanForUser',
}

enum ComponentSubscriptionStatusTag {
  Trial = 'Component-Subscription-Status-Tag-Trial',
  Paused = 'Component-Subscription-Status-Tag-Paused',
  PaymentRequired = 'Component-Subscription-Status-Tag-PaymentRequired',
  Canceled = 'Component-Subscription-Status-Tag-Canceled',
  PaymentError = 'Component-Subscription-Status-Tag-PaymentError',
}

enum ComponentSubscriptionIncoicesCard {
  ViewAllInvoices = 'Component-Subscription-Invoices-Card-ViewAllInvoices',
}

enum ComponentSubscriptionSummaryCard {
  Plan = 'Component-Subscription-Summary-Card-Plan',
  NextPayment = 'Component-Subscription-Summary-Card-NextPayment',
  Monthly = 'Component-Subscription-Summary-Card-Monthly',
  Annual = 'Component-Subscription-Summary-Card-Annual',
  SaveWithAnnualPayment = 'Component-Subscription-Summary-Card-SaveWithAnnualPayment',
}

/**
 *
 */

enum Error {
  Required = 'Misc-Error-Required',
  TypeString = 'Misc-Error-TypeString',
  TypeNumber = 'Misc-Error-TypeNumber',
  TypeLink = 'Misc-Error-TypeLink',
  TypeEmail = 'Misc-Error-TypeEmail',
  NotValidPhone = 'Misc-Error-NotValidPhone',
  MinLength = 'Misc-Error-MinLength',
  Caps = 'Misc-Error-Caps',
  Lowercase = 'Misc-Error-Lowercase',
  ContainsNumber = 'Misc-Error-ContainsNumber',
  ContainsSymbol = 'Misc-Error-ContainsSymbol',
  MismatchValue = 'Misc-Error-MismatchValue',
}

enum Form {
  Title = 'Misc-Form-Title',
  Description = 'Misc-Form-Description',
  Name = 'Misc-Form-Name',
  Slug = 'Misc-Form-Slug',
  FirstName = 'Misc-Form-FirstName',
  LastName = 'Misc-Form-LastName',
  Username = 'Misc-Form-Username',
  Email = 'Misc-Form-Email',
  Phone = 'Misc-Form-Phone',
  Password = 'Misc-Form-Password',
  PasswordConfirmation = 'Misc-Form-Password-Confirmation',
  RememberMe = 'Misc-Form-RememberMe',
  Add = 'Misc-Form-Add',
  Label = 'Misc-Form-Label',
  URL = 'Misc-Form-URL',
  Message = 'Misc-Form-Message',
  Minutes = 'Misc-Form-Minutes',
  Seconds = 'Misc-Form-Seconds',
  Hours = 'Misc-Form-Hours',

  Attachment = 'Misc-Form-Attachment',
  AddAttachment = 'Misc-Form-AddAttachment',
  FileSizeExceeds = 'Misc-Form-FileSizeExceeds',
  FileClicOrDrag = 'Misc-Form-FileClicOrDrag',
  FileCanBe = 'Misc-Form-FileCanBe',
  FileMaxSize = 'Misc-Form-FileMaxSize',

  Buttons = 'Misc-Form-Buttons',
  AddButtonInteraction = 'Misc-Form-AddButtonInteraction',

  AreYouSureToDelete = 'Misc-Form-AreYouSureToDelete',
}

enum Button {
  Update = 'Misc-Button-Update',
  Delete = 'Misc-Button-Delete',
  Save = 'Misc-Button-Save',
  Cancel = 'Misc-Button-Cancel',
  Help = 'Misc-Button-Help',
}

enum AuthError {
  LoginError = 'Auth-Error-LoginError',
}

enum SBRM {
  EntityNotDefined = 'SBRM-EntityNotDefined',
  Close = 'SBRM-Close',
  Delete = 'SBRM-Delete',
  Save = 'SBRM-Save',
  Update = 'SBRM-Update',
  ContactAssociatedWithUserNotEditable = 'SBRM-ContactAssociatedWithUserNotEditable',
  AddNew = 'SBRM-AddNew',
  Duplicate = 'SBRM-Duplicate',
  View = 'SBRM-View',
  Comment = 'SBRM-Comment',
  DeleteConfirmation = 'Are you sure to delete?',
}

enum SBRMTitle {
  AddNew = 'SBRM-Title-AddNew',
  CreateNew = 'SBRM-Title-CreateNew',
  Edit = 'SBRM-Title-Edit',
  Delete = 'SBRM-Title-Delete',
  Comment = 'SBRM-Title-Comment',
  View = 'SBRM-Title-View',
  Upload = 'SBRM-Title-Upload',
  Duplicate = 'SBRM-Title-Duplicate',
  Assign = 'SBRM-Title-Assign',
  Invite = 'SBRM-Title-Invite',
  Cancel = 'SBRM-Title-Cancel',
}

enum Entity {
  user = 'user',
  profile = 'profile',
  automation = 'automation',
  answer = 'answer',
  contact = 'contact',
  analyticsEvent = 'analyticsEvent',
}

const LocalizationKeys = {
  Page: {
    Login: Login,
    Register: Register,
    ForgotPassword: ForgotPassword,
    ResetPassord: ResetPassord,
    ProfilesPage: ProfilesPage,
    ContactsPage: ContactsPage,
    AutomationPage: AutomationPage,
    ProfileSettingsPage: ProfileSettingsPage,
    UserProfilePage: UserProfilePage,
    OnboardingRegistrationPage: OnboardingRegistrationPage,
    OnboardingStepsIndustryPage: OnboardingStepsIndustryPage,
    OnboardingStepsNamePage: OnboardingStepsNamePage,
    OnboardingStepsEmailPage: OnboardingStepsEmailPage,
    OnboardingStepsPasswordPage: OnboardingStepsPasswordPage,
    ProfileFormDeletePage: ProfileFormDeletePage,
  },
  Component: {
    Answer: {
      Analytics: ComponentAnswerAnalytics,
      Card: ComponentAnswerCard,
      List: ComponentAnswerList,
    },
    Automation: {
      Update: ComponentAutomationUpdate,
    },
    Profile: {
      AddCard: ComponentProfileAddCard,
      BillingPortal: ComponentProfileBillingPortal,
      ConnectFlow: ComponentProfileConnectFlow,
      Card: ComponentProfileCard,
    },
    Subscription: {
      StatusTag: ComponentSubscriptionStatusTag,
      InvoicesCard: ComponentSubscriptionIncoicesCard,
      SummaryCard: ComponentSubscriptionSummaryCard,
    },
  },
  Layout: {
    ProfileHeader: LayoutProfileHeader,
    RightHeader: LayoutRightHeader,
  },
  Auth: {
    Error: AuthError,
  },
  Misc: {
    Error: Error,
    Form: Form,
    Button: Button,
  },
  SBRM: SBRM,
  SBRMTitle: SBRMTitle,
  Entity: Entity,
}

export default LocalizationKeys
